import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const FormItem = ({ id, label, value: itemValue, type = 'text', ...other }) => {
    let { touched, error, value, onBlur, onChange, onKeyPress } = itemValue;
    if(!value) value = '';
    
    const showError = touched && error;
    const itemClass = classnames('form-item', {
        'form-item--error': showError
    });
    
    return (
        <div className={itemClass}>
            {showError &&
                <div className="error-message">{error}</div>    
            }
            <label htmlFor={id} className="u-visual-hidden">{label}</label>
            <input type={type} value={value} onBlur={onBlur} onChange={onChange} onKeyPress={onKeyPress} placeholder={label} id={id} {...other} />
        </div>
    );
};

FormItem.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.object.isRequired
};

export default FormItem;